export default "__VITE_ASSET__BBl08w6O__"